import { Search, SlidersHorizontal } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { MODULE_CATEGORY_LABELS, type ModuleCategory } from "@/data/modules";

const ALL_TAB = "all";

interface ModuleFilterBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  activeCategory: ModuleCategory | typeof ALL_TAB;
  onCategoryChange: (value: ModuleCategory | typeof ALL_TAB) => void;
  showSelectedOnly: boolean;
  onShowSelectedOnlyChange: (value: boolean) => void;
}

const CATEGORY_TABS: Array<{ value: ModuleCategory | typeof ALL_TAB; label: string }> = [
  { value: ALL_TAB, label: "Alle" },
  ...Object.entries(MODULE_CATEGORY_LABELS).map(([value, label]) => ({
    value: value as ModuleCategory,
    label,
  })),
];

export function ModuleFilterBar({
  search,
  onSearchChange,
  activeCategory,
  onCategoryChange,
  showSelectedOnly,
  onShowSelectedOnlyChange,
}: ModuleFilterBarProps) {
  return (
    <div className="flex flex-col gap-3">
      {/* Search + toggle row */}
      <div className="flex items-center gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
          <Input
            placeholder="Module suchen …"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9 h-9 text-sm"
          />
        </div>

        <div className="flex items-center gap-2">
          <Switch
            id="show-selected"
            checked={showSelectedOnly}
            onCheckedChange={onShowSelectedOnlyChange}
            className="data-[state=checked]:bg-primary"
          />
          <Label htmlFor="show-selected" className="text-sm text-muted-foreground cursor-pointer select-none">
            Nur Ausgewählte
          </Label>
        </div>
      </div>

      {/* Category tabs */}
      <Tabs
        value={activeCategory}
        onValueChange={(v) => onCategoryChange(v as ModuleCategory | typeof ALL_TAB)}
        className="w-full"
      >
        <TabsList className="h-auto flex-wrap gap-1 bg-muted/60 p-1 rounded-lg">
          {CATEGORY_TABS.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="text-xs px-3 py-1.5 rounded-md data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
}
